//英语
export default {
	desktopMobilePage: 'Mobile Page',
	voteAction: 'Vote',
	videoNavLabel: 'Video',
	vipLevelLabel: 'VIP Level',
	betOptions: { rose: 'Rose', lily: 'Lily', fireworks: 'Fireworks', balloon: 'Balloon' },
	Language: 'English',
	registerPasswordLength: 'Password must be 6 to 12 characters long',
	system: {
		homePage: {
			title1: 'Title 1',
			title2: 'Title 2',
			description1: 'Last 7 days',
			description2: 'Last 6 months',
		}
	},
	login:{
		subtitle:'Begin your exclusive encounter tonight',
		register:'Register',
		usernamePls:'Please enter username',
		passwordPls:'Please enter password',
		toRegister:'No account? Sign up now',
		doLogin:'Login',	  
		loginFailed:'Login failed. Please try again',
	},
	googleAuth:{
		or:'or',
		processing:'Verifying your Google account…',
		configMissing:'Google sign-in has not been configured',
		unavailable:'Google sign-in is temporarily unavailable',
		failed:'Google sign-in failed. Please try again',
		invalidResponse:'The login service did not return a valid credential',
		success:'Signed in with Google',
		inviteTitle:'Enter invitation code',
		inviteDescription:'This Google account is entering for the first time. Enter a valid invitation code to create your account. Future sign-ins will continue directly.',
		cancel:'Cancel',
		continue:'Continue'
	},
	register:{
		repasswordPls:'Please enter withdrawal password',  
		codePls:'Please enter invitation code',  
		register:'Register',
		xieyi:'Agree to Terms of Service',
		xieyiPls:'Please select the account opening agreement below!',
	},
	mine:{
		xyfs:'Credit Score',
		ljjf:'Accumulated Points',
		recharge:'Recharge',
		withdraw:'Withdraw',
		money:'Available Balance',
		infomation:'Basic Information',
		moneylog:'Points History',
		withdrawrecord:'Withdrawal Records',
		gamerecord:'Gift Records',
		notice:'Announcements',
		mymove:'Viewing History',
		loginpwd:'Login Password',
		paypwd:'Payment Password',
		loginout:'Logout',
		paypwdhasseted:'Withdrawal password has been set. If modification is needed, please contact customer service',
		setbank:'Please set up your withdrawal card!',
		lorr:'Login/Register',
	},
	infomation:{
		username:'Member ID',
		name:'Name',
		bankcard:'Withdrawal Account',
		phone:'Phone Number',
		recharge:'Recharge',
		amount:'Available Points',
		toserve:'Please contact customer service',
		kfms:'For offline recharge, please contact customer service. Some payment channels will randomly recharge to 1 decimal place, please confirm during payment',
	},
	withdraw:{
		title:'Point Exchange',
		log:'Withdrawal Records',
		method:'Withdrawal Method',
		avmoney:'Available Points',
		limit:'Withdrawal Limit',
		submit:'Point Withdrawal Request',
		xiane:'Single Limit',
		numbers:'Withdrawal Count',
		time:'Deposit Time',
		zuidi:'Minimum',
		zuigao:'Maximum',
		numsmax:'Daily Max Withdrawal',
		ci:'Times',
		timedetail:'Usually deposit time is about 5 minutes, fastest within 2 minutes',
		bank:'Bank Card',
		status1:'Pending',
		status2:'Withdrawal Complete',
		status3:'Withdrawal Failed',
		enterCorrectAmount: 'Please enter correct amount',
		selectBankCard: 'Please select withdrawal bank card',
		enterPayPassword: 'Please enter payment password',
	},
	moneylog:{
		title:'Point Details',
		type1:'Recharge',
		type2:'Bonus',
		type3:'Task',
		type4:'Bonus',
		type5:'Withdrawal Complete',
		type6:'Withdrawal Failed',
		rechargeNote: '(Recharge)',
		summary: 'No timestamp',
	},
	setting:{
		loginpwdtitle:'Change Login Password',
		oldpwd:'Please enter old password',
		newpwd:'Please enter new password',
		renewpwd:'Please re-enter new password',
		change:'Change',
		plseall:'Passwords do not match!',
		pswwrong:'Password input does not match twice',
		paypwdtitle:'Set Fund Password',
		paypwd:'Please enter withdrawal account password',
		repaypwd:'Please confirm password again',
		title: 'Settings',
		basicInfo: 'Basic Information Settings',
		loginPassword: 'Login Password',
		fundPassword: 'Fund Password',
		logout: 'Logout',
		payPasswordSet: 'Withdrawal password has been set. If modification is needed, please contact customer service',
		payPasswordNotSet: 'Not Set',
		payPasswordHasSet: 'Set',
		confirm: 'Confirm',
	},
	home:{
		gonggao:'Enjoy the ultimate luxury experience',
		qgkf:'Nationwide Available',
		hotlist:'Popular Recommendations',
		hotgame:'Task Activation',
		gaoji:'Premium',
		smrz:'Real Person Verification',
		videorz:'Personal Video Verification',
		star:'Rating',
		sg:'Height',
		xw:'Size',
		diqu:'Service Available Areas',
		apply:'Apply for Date',
		ssxz:'Real-time Status',
		joinvip:'has joined as member',
	},
	video:{
		latest:'Latest',
		title:'Video Gallery',
		nums:'View Count',
		bofangliang:'Times Played',
		hotlist:'Hot Recommendations',
		plsrefisrt:'Please recharge before watching video!',
	// ... other video translations
	    trialEnded: 'Trial Ended',
	    rechargeToWatch: 'Please recharge to continue watching for free',
	    goRecharge: 'Recharge Now',
	},
	choose:{
		title:'Best One Night',
		nav:'Profile',
		apply:'Matching Application',
		jianjie:'Manager Profile',
		move:'Mobility Available',
		click:'Click to verify',
		giftPoints:'Gift Flower Points',
		giftTitle:'Gift Flower Points',
		giftBalance:'Available Points:',
		giftAmount:'Flower Points',
		giftCustomPlaceholder:'Enter flower points',
		giftConfirm:'Confirm Gift',
		giftSending:'Sending...',
		giftSuccess:'Flower points sent successfully',
		giftInvalid:'Enter a whole number from 1 to 1,000,000',
		giftInsufficient:'Insufficient available points',
		detail:'Details',
		videodetail:'Live Video',
	},
	common:{
		refresh:'Refresh successful',
		refreshSuccess:'Refresh successful',
		refreshFailed:'Refresh failed',
		loadFailed:'Failed to load data',
		loadFail:'Failed to load data',
		networkError:'Network error. Please try again',
		imageTooLarge:'Image must be smaller than 5 MB',
		uploading:'Uploading...',
		uploadFailed:'Upload failed',
		contactAdvisor:'Please contact an advisor or receptionist',
		usingCachedData:'Using cached data',
		confirmClearCache:'Clear all cached data? This action cannot be undone.',
		confirmDeleteHistory:'Delete this viewing record?',
		deleteSuccess:'Deleted successfully',
		deleteFailed:'Delete failed',
		noallow:'Function is disabled!',
		disable:'Disabled',
		all:'All',
		nomore:'No more',
		nodata:'No data',
		submit:'Submit',
		more:'View more managers',
		pinglunnav:'Reviews',
		pingluntitle:'Manager Reviews',
		pldtitle:'Review Details',
		minenav:'Account',
		homenav:'Home',
		addbank:'Add Payment Card',
		setbank:'Register Withdrawal Account',
	},
	game:{
		expect:'Period',
		jieguo:'Data',
		da:'Big',
		xiao:'Small',
		dan:'Odd',
		shuang:'Even',
		大:'Big',
		小:'Small',
		单:'Odd',
		双:'Even',
		order:'Task Specification',
		clear:'Clear Order',
		submit:'Confirm Submit',
		rewardSuccess:'Tip sent successfully',
		kjcc:'Winning successful, period:',
		lxgly:'Please contact your administrator for this task',
		plsmoney:'Please enter amount!',
		plsnum:'Please select number!',
		moneynote:'Insufficient balance, please contact customer service to recharge!',
		lefttime:'Remaining Time',
		lunci:'Period',
		workRecord: 'Task Record',
		day: 'Day',
		period: 'Period',
		allWork: 'All Tasks',
		reset: 'Reset',
		confirm: 'Confirm',
		bonusPoints: 'Bonus Points',
		missionMoney: 'Task Money Details',
		missionResult: 'Task Result',
		points: 'Points',
		workPoints: 'Task Points',
		giftCompleted: 'Gift Completed',
		orderTime: 'Order Time:',
		detail: 'Detail',
		content: 'Content',
		amount: 'Amount',
		result: 'Result',
		time: 'Time',
		win: 'Win',
		missionFailed: 'Task Failed',
	},
	kefu:{
		title:'Online Customer Service',
		lianxi:'Contact',
		content:'24/7 dedicated service',
		defaultName: 'Online Service',
	},
	setname:{
		title:'Modify Real Name',
		xingming:'Name',
		tips:'For your account security, real name must match bound bank card name',
		xmpls:'Please enter real name',
		save:'Save',
		notreset:'Do not repeat settings!',
		plsentername:'Please enter name!',
	},
	// Additional language keys
	withdrawCenter: 'Withdrawal Center',
	withdrawRecord: 'Withdrawal Record',
	withdrawAmount: 'Withdrawal Amount',
	allMoney: 'All',
	singleLimit: 'Single Limit',
	lowest: 'Lowest',
	highest: 'Highest',
	withdrawTimes: 'Withdrawal Times',
	maxDailyWithdraw: 'Max Daily Withdrawal',
	times: 'Times',
	arrivalTime: 'Arrival Time',
	limitDescription: 'Limit Description',
	balance: 'Balance',
	withdrawNow: 'Withdraw Now',
	enterCorrectAmount: 'Please enter correct amount',
	personalReport: 'Personal Report',
	profitAmount: 'Profit Amount',
	profitFormula: 'Profit calculation formula: Winning amount - Task amount',
	taskAmount: 'Task Amount',
	accountOffline: 'Account Offline',
	loginRegister: 'Login/Register',
	loginForMore: 'Login to enjoy more services!',
	// Comment related
	author: 'Author:',
	notification: 'Notification',
	// Settings related
	changePhone: 'Change Phone Number',
	save: 'Save',
	existingPhone: 'Existing Phone Number',
	newPhone: 'New Phone Number',
	// Bank related
	withdrawAccountRegister: 'Withdrawal Account Registration',
	selectBankCard: 'Please select bank card',
	accountNumber: 'Account Number',
	enterBankCardNumber: 'Please enter bank card number',
	// Notification related
	systemNotice: 'System Notice',
	// Viewing record related
	myMovie: 'My Movie',
	completeTaskForMore: 'Complete tasks to get more movie tickets',
	movieTicket: 'Movie Ticket:',
	watchList: 'Watch List',
	noDataYet: 'No data yet',
	// Others
	setNameFirst: 'Please set your name first before linking withdrawal account!',
	setPasswordFirst: 'Please set withdrawal password first before binding bank card!',
	// Bank related
	accountHolder: 'Account Holder',
	enterRealName: 'Please enter real name',
	withdrawPassword: 'Withdrawal Password',
	registerWithdrawPassword: 'Please register withdrawal password',
	bankCard: 'Bank Card',
	// Game related
	orderContentLabel: 'Order Content:',
	all: 'All',
	bonusPointsLabel: 'Bonus Points',
	waitingResultLabel: 'Waiting for Result',
	missionMoneyDetails: 'Mission Money Details',
	points: 'Points',
	// Lottery related
	switch: 'Switch',
	currentSelection: 'Current Selection:',
	quantity: 'Quantity:',
	total: 'Total',
	ticketAmount: 'Ticket Amount',
	availablePoints: 'Available Points',
	verify: 'Verify',
	// Profile related
	possible: 'Possible',
	thumb: 'Thumb',
	privacyPolicy: 'Privacy Policy',
	romanticDescription: 'Our romantic service protects member privacy by requiring real-name verification or recommendation from verified members to register.',
	// Home related
	person1: 'Xia Yu',
	person2: 'Min Xue',
	lishijl: 'History Record',
	cryptoWithdraw: { title:'Crypto Withdrawal',record:'Records',assetTitle:'Digital Asset Withdrawal',assetSubtitle:'Secure transfer to your crypto wallet',selectCoin:'Select Coin',selectNetwork:'Select Network',walletAddress:'Receiving Wallet Address',walletPlaceholder:'Enter wallet address',addressTip:'Make sure the address supports {network}. Transfers cannot be reversed.',amount:'Withdrawal Amount',all:'All',availableBalance:'Available Balance',network:'Network',fee:'Estimated Fee',arrival:'Estimated Arrival',confirm:'Confirm Withdrawal',submitting:'Submitting...',safetyInfo:'Withdrawal Safety',safetyCaption:'Payment password and encryption protect your funds',verification:'Security Verification',passwordPrompt:'Enter your payment password to confirm',payPassword:'Payment Password',passwordPlaceholder:'Enter payment password',cancel:'Cancel',rulesTitle:'Crypto Withdrawal Guide',rule1:'Make sure the wallet supports the selected coin and network.',rule2:'Withdrawal requests are subject to security review.',rule3:'Arrival time depends on blockchain network conditions.',rule4:'Completed transactions cannot be reversed. Check the address carefully.',enterAddress:'Enter a receiving wallet address',invalidAddress:'Address does not match the selected network',invalidAmount:'Amount must exceed the network fee',insufficientBalance:'Amount exceeds available balance',enterPassword:'Enter your payment password',passwordError:'Incorrect payment password',success:'Withdrawal request submitted',failed:'Withdrawal failed. Please try again' },
	cryptoAddress:{bind:'Bind Address',title:'Bind Withdrawal Address',selectCoin:'Select Coin',selectNetwork:'Select Network',address:'Wallet Address',placeholder:'Enter wallet address',tip:'Make sure the wallet supports the selected coin and network.',save:'Save Address',modify:'Modify Address',saving:'Saving...',invalid:'Invalid wallet address',success:'Address saved',scanSuccess:'QR code recognized',scanFail:'No valid wallet QR code found',verify:'Verify Transaction Password',password:'Transaction Password',passwordPlaceholder:'Enter transaction password',confirm:'Confirm modification',cancel:'Cancel',passwordRequired:'Enter transaction password'},
};
